import React from 'react';
import { t } from '../../../../utils/i18n';
import { DH } from '../../../../utils/dataHooks';
import { useExpressButtons } from '../../hooks/useExpressButtons';
import { ExpressButtons } from '../ExpressButtons';
import { Divider } from '../Divider';
import { st, classes } from './styles.st.css';

export const Fieldset: React.FC = () => {
  const { items } = useExpressButtons();

  return (
    <>
      <fieldset data-hook={DH.Widget.HorizontalLayoutFieldset} className={st(classes.root)}>
        <legend className={st(classes.header)}>{t('horizontalLayout.header')}</legend>
        <ExpressButtons items={items} place="onTopLevel" dataHook={DH.Widget.PMList} />
      </fieldset>
      <Divider />
    </>
  );
};
